import { MobileLayoutProps } from '../types';

/**
 * MobileLayout Component
 * 
 * Simple wrapper that conditionally renders list or detail view based on showDetailView prop.
 * Handles navigation between mobile list and detail views.
 */
export function MobileLayout({ showDetailView, children }: MobileLayoutProps) {
  return <>{showDetailView ? children.detail : children.list}</>;
}

